import { apiRequest } from '../http.js'

export const metricEvidenceApi = {
  getPresignedUpload: async ({ campaignId, deliverableId, filename, contentType }) => {
    const qs = new URLSearchParams({
      campaignId,
      deliverable_id: deliverableId,
      filename,
      ...(contentType ? { contentType } : {}),
    })
    return apiRequest(`/metric-evidence/presigned-upload?${qs.toString()}`)
  },

  create: async (body) => {
    return apiRequest('/metric-evidence', {
      method: 'POST',
      body: JSON.stringify(body),
    })
  },

  uploadLocal: async (formData) => {
    return apiRequest('/metric-evidence/upload', {
      method: 'POST',
      body: formData,
    })
  },

  listMine: async ({ campaignId, deliverableId } = {}) => {
    const params = new URLSearchParams()
    if (campaignId) params.set('campaign_id', campaignId)
    if (deliverableId) params.set('deliverable_id', deliverableId)
    const qs = params.toString() ? `?${params.toString()}` : ''
    const data = await apiRequest(`/metric-evidence/mine${qs}`)
    return data.evidence || []
  },

  getPendingReview: async () => {
    const data = await apiRequest('/metric-evidence/pending-review')
    return data.evidence || []
  },

  approve: async (evidenceId, body = {}) => {
    return apiRequest(`/metric-evidence/${evidenceId}/approve`, {
      method: 'POST',
      body: JSON.stringify(body),
    })
  },

  reject: async (evidenceId, body = {}) => {
    return apiRequest(`/metric-evidence/${evidenceId}/reject`, {
      method: 'POST',
      body: JSON.stringify(body),
    })
  },

  releaseToClient: async (evidenceId) => {
    return apiRequest(`/metric-evidence/${evidenceId}/release-to-client`, { method: 'POST' })
  },

  retryParse: async (evidenceId) => {
    return apiRequest(`/metric-evidence/${evidenceId}/parse`, { method: 'POST' })
  },

  getById: async (evidenceId) => {
    const data = await apiRequest(`/metric-evidence/${evidenceId}`)
    return data.evidence
  },

  getAssignmentSummary: async (assignmentIds = []) => {
    const ids = (assignmentIds || []).filter(Boolean)
    if (!ids.length) return {}
    const qs = `?assignment_ids=${encodeURIComponent(ids.join(','))}`
    const data = await apiRequest(`/metric-evidence/assignment-summary${qs}`)
    return data.summaries || {}
  },

  getMetricsAttribution: async (assignmentIds = []) => {
    const ids = (assignmentIds || []).filter(Boolean)
    if (!ids.length) return {}
    const qs = `?assignment_ids=${encodeURIComponent(ids.join(','))}`
    const data = await apiRequest(`/metric-evidence/metrics-attribution${qs}`)
    return data.attributions || {}
  },
}
